import React, {useEffect, useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';
import {myService} from '@app/services/bieumautailieuService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";
import {useSelector} from "react-redux";
import {HRTag, Tabs} from "@components";
import {
    root_path, INIT_ROLE_MENU, bieumautailieu_METHOD
} from "@app/const/AppSetting";
import TailieuEdit from '@app/pages/FMasterData/FBieumautailieu/TailieuEdit';
import {useTranslation} from "react-i18next";
import MyReactDatePicker from "@app/utils/MyReactDatePicker";
import {findObjInArr} from "@app/utils/CommonFunctions";
import LoaibieumautailieuListComponent from '@app/pages/FUtil/LoaibieumautailieuListComponent';
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import {ClipLoader} from "react-spinners";
import ReactPlayer from "react-player";
import Editor from "@pages/FUtil/Editor";

function BieumautailieuEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    // Refs for scrollTo functionality
    const taiLieuRef = useRef(null);
    const thongTinRef = useRef(null);
    const noiDungRef = useRef(null);

    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    // ScrollTo functions
    const scrollToThongtin = () => {
        thongTinRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToNoiDung = () => {
        noiDungRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToTaiLieu = () => {
        taiLieuRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const initial = {
        id: id || 0,
        loaibieumautailieu_fk: null,
        ten : '',
        noi_dung: '',
        trangthai_fk: null
    };

    const [obj, setObj] = useState({...initial});

    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;

        if(name ==="xyz") {
            // Handle special cases if needed
        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const createRs = async () => {
        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                setObj(userX);
            });
        }
    };

    useEffect(async () => {
        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });

        await createRs();
    }, []);

    const saveClick = async () => {
        let data = obj;

        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
        if(!data.loaibieumautailieu_fk || data.loaibieumautailieu_fk === 0)
        {
            alert('Vui lòng chọn loại biểu mẫu tài liệu');
            return;
        }
        if(!data.ten || data.ten.length === 0)
        {
            alert('Vui lòng nhập tên biểu mẫu tài liệu');
            return;
        }
        isAddMode ?  await createUser(data) : update(data);
    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    const downloadFile = async (id) => {
        try {
            const response = await myService.downloadFile(id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            console.log(response.data);
            console.log("Content-Disposition Header:", contentDisposition);
            let fileName = 'downloaded_file';
            if (contentDisposition) {
                console.log('header: '+contentDisposition);
                const matches = /filename\*=(?:UTF-8'')?([^;\n]+)/.exec(contentDisposition) || /filename="([^"]+)"/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
                }
            }
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
            alert('Có lỗi xảy ra khi tải file.');
        }
    };

    async function createUser(data) {
        setLoading(true);
        const result = await myService.Create(data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            history.push('/'+currController+'/edit/'+ result.data );
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    async function update(data) {
        setLoading(true);
        const result = await myService.Update(id,data);

        if (result.status ==="1") {
            alertService.success(result.msg);
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';

    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
                className="btn btn-success mr-1"
                icon="right fas fa-angle-left"
                onClick={saveClick}
            >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"} </i>
            </Button>
        );
    }

    // CSS Styles
    const formLabelStyle = {
        fontWeight: '500',
        color: '#495057',
        marginBottom: '5px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    };

    const formControlStyle = {
        border: '1px solid #ced4da',
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff'
    };

    const iconStyle = {
        fontSize: '14px',
        marginRight: '8px'
    };

    return (
        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                {/* Navigation buttons - Fixed on right side */}
                { !isAddMode && (
                    <div style={{
                        position: 'fixed',
                        right: '0',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '1000',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToThongtin}
                        >
                            Thông tin chung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToNoiDung}
                        >
                            Nội dung
                        </button>
                        <button
                            style={{
                                background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '20px 0 0 20px',
                                fontSize: '13px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                minWidth: '140px',
                                boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateX(-5px)';
                                e.target.style.boxShadow = '-4px 0 12px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateX(0)';
                                e.target.style.boxShadow = '-2px 0 6px rgba(0, 0, 0, 0.1)';
                            }}
                            onClick={scrollToTaiLieu}
                        >
                            Tài liệu
                        </button>
                    </div>
                )}

                <div className="form-row p-2">
                    <Button className="btn btn-secondary  mr-1"  onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>

                <div className="tab-pane fade show active" id="thongtinnhanvien">
                    <div className="card-body" ref={thongTinRef}>
                        <HRTag title="Thông tin biểu mẫu tài liệu" />

                        {/* Row 1: Loại biểu mẫu và Tên */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <LoaibieumautailieuListComponent
                                    loaibieumautailieu_fk={obj.loaibieumautailieu_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "loaibieumautailieu_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <label style={{...formLabelStyle, fontWeight: '600'}}>
                                    <i className="fas fa-file-alt text-primary" style={iconStyle}></i>
                                    Tên biểu mẫu <span style={{color: '#dc3545', marginLeft: '3px'}}>*</span>
                                </label>
                                <input
                                    type='text'
                                    className="form-control"
                                    style={formControlStyle}
                                    name="ten"
                                    id="ten"
                                    value={obj.ten}
                                    onChange={(e) => onChangeInput(e)}
                                    placeholder="Nhập tên biểu mẫu tài liệu"
                                />
                            </div>
                        </div>

                        {/* Row 2: Trạng thái */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <TrangthaiListComponent
                                    trangthai_fk={obj.trangthai_fk}
                                    onChange={(opt, e) => {
                                        const target = {name: "trangthai_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                    filterIds={[0,1]}
                                    trangthaiName="name"
                                />
                            </div>
                            <div className="col-md-6">
                                {/* Reserved for future fields */}
                            </div>
                        </div>

                        {/* Nội dung Section */}
                        <div ref={noiDungRef}>
                            <HRTag title="Nội dung biểu mẫu" />

                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label style={formLabelStyle}>
                                        <i className="fas fa-edit text-success" style={iconStyle}></i>
                                        Nội dung chi tiết
                                    </label>
                                    <Editor
                                        name="noi_dung"
                                        value={obj.noi_dung}
                                        onChange={onChangeInput}
                                        readonly={isDisplay ? "readonly" : ""}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Tài liệu Section */}
                        {!isAddMode && (
                            <div ref={taiLieuRef}>
                                <HRTag title="Tài liệu đính kèm" />
                                <TailieuEdit id={id} />
                            </div>
                        )}

                        {/* Commented out sections for future use
                        {!isAddMode && obj.id && (
                            <div className='col-md-6'>
                                <label style={formLabelStyle}>
                                    <i className="fas fa-file-download text-info" style={iconStyle}></i>
                                    File hiện tại:
                                </label>
                                {isImageOrPDF(obj.image) ? (
                                    isImage(obj.image) ? (
                                        <img src={`${root_path}${obj.image}`} alt="preview" style={{ maxWidth: '100%', maxHeight: '300px' }} />
                                    ) : (
                                        <embed src={`${root_path}${obj.image}`} type="application/pdf" width="100%" height="300px" />
                                    )
                                ) : (
                                    <a
                                        href="#"
                                        className="btn btn-primary"
                                        style={{ display: 'block', marginTop: '10px' }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            downloadFile(obj.id);
                                        }}
                                    >
                                        <i className="fas fa-download" /> Tải file
                                    </a>
                                )}
                            </div>
                        )}
                        */}
                    </div>
                </div>
            </div>

            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>
        </div>
    );
}

export {BieumautailieuEdit};